import React from 'react'
import { Button, Icon } from 'semantic-ui-react'
import { fetchAPI } from '@bsd/dashboard-toolkit/utils'

import { getStaticPath } from '../../utils'

class GeoObjectImagesField extends React.Component {

  fileInputRef = React.createRef()

  clickFileInput = (e) => {
    if (e) { e.preventDefault() }
    this.fileInputRef.current.click()
  }

  handleFilesSelect = async (e) => {
    if (e) { e.preventDefault() }
    const files = [...e.target.files]
    e.target.value = ''
    if (!files || !files.length) {
      return
    }
    const imageDatas = await Promise.all(
      files.map(file =>
        fetchAPI(`/in/globe3d/images`, 'POST', { image: file }, true)))
    this.props.onChange([...this.props.value, ...imageDatas])
  }

  handleDeleteImage = async (idx) => {
    this.props.onChange([
      ...this.props.value.slice(0, idx),
      ...this.props.value.slice(idx + 1),
    ])
  }

  render() {
    const { value = [] } = this.props
    return (
      <div>
        <Button basic icon='upload' size='mini' content='Загрузить файлы' onClick={this.clickFileInput}/>
        <div style={{ marginTop: '15px', display: 'flex', flexFlow: 'wrap' }}>
          {value.map((img, idx) =>
            <div key={`${idx}_${img.size}`} style={{ maxHeight: '100px' }}>
              <div style={{ display: 'flex', maxHeight: '100px', alignItems: 'top', margin: '5px' }} >
                <div style={{ cursor: 'pointer' }} onClick={() => this.handleDeleteImage(idx)}>
                  <Icon name='delete' color='red'/>
                </div>
                <img
                  style={{ objectFit: 'cover', maxHeight: '100px' }}
                  src={getStaticPath(img.url)}
                />
              </div>
            </div>)}

        </div>
        <input
          type='file'
          accept='image/*'
          style={{ display: 'none' }}
          ref={this.fileInputRef}
          onChange={this.handleFilesSelect}
          multiple
        />
      </div>
    )
  }

}

export default GeoObjectImagesField